import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import "./SupplementsNote.css";

type Props = {
    onClickLink: () => void;
};

export const SupplementsNote = (props: Props) => {
    const { onClickLink } = props;

    const { t } = useTranslation("locale");

    const [show, setShow] = useState(true);

    const onClose = useCallback(() => setShow(false), []);

    if (!show) {
        return null;
    }

    return (
        <div className="supplements-note">
            <div className="flex flex-row align-items-center">
                <span className="pi pi-info-circle supplements-icon" />
                <p>
                    {t("documents.supplementsNote")}
                    <span
                        className="supplements-link"
                        onClick={onClickLink}
                    >{` ${t("documents.supplements")}`}</span>
                    <span>{` ${t("documents.tab")}.`}</span>
                </p>
            </div>
            <span className="pi pi-times supplements-close" onClick={onClose} />
        </div>
    );
};
